import { i18n, i18nPlurals } from "../../domain/i18n.js";

export default {
  [i18nPlurals.brands["0"]]: 'Brands',
  [i18nPlurals.brands["1"]]: 'Brand',
  [i18nPlurals.brands["2"]]: 'Brands',

  [i18n.generic.authorizedBy]: '(es) authorized.by',
  [i18n.generic.brands]: '{count} [brands]',

  [i18n.alt.authorizedBySeal]: '(authorized.by)',
  [i18n.alt.tuvSeal]: '(TÜV Saarland ShopIdent)',

  [i18n.menu.checkAuthorizations.caption]: 'Validate Authorizations',
  [i18n.menu.imprint.caption]: 'Imprint',
  [i18n.menu.imprint.link]: 'https://www.authorized.by/en/imprint/',
  [i18n.menu.privacyPolicy.caption]: 'Privacy Policy',
  [i18n.menu.privacyPolicy.link]: 'https://www.authorized.by/en/privacy-policy/',

  [i18n.header.texts.full.isAuthorized1]: '{url}',
  [i18n.header.texts.full.isAuthorized2]: 'is an authorized online partner',
  [i18n.header.texts.full.isAuthorized2_t0NotApproved]: 'Este sitio es nuevo en <a href="https://www.authorized.by/" target="_blank">authorized.by</a> y espera aprobación para ser autorizado por Brands',
  [i18n.header.texts.full.isAuthorized2_t0NoBrands]: 'Este sitio es nuevo en <a href="https://www.authorized.by/" target="_blank">authorized.by</a> y espera autorizaciones de Brands',
  [i18n.header.texts.full.isAuthorized3]: 'of the following {brands}',
  [i18n.header.texts.full.brands]: '{count} [brands]:',
  [i18n.header.texts.brandLink.multiple]: '{brandName} + {count} more brands',
  [i18n.header.texts.brandLink.two]: '{brandName} + 1 more brand',
  [i18n.header.texts.brandLink.one]: '{brandName}',

  [i18n.contents.texts.lastVerified]: 'Last authorized',
  [i18n.contents.texts.lastVerified_t0NotApproved]: '<a href="https://app.authorized.by/" target="_blank">En espera aprobacion</a>',
  [i18n.contents.texts.lastVerified_t0NoBrands]: '<a href="https://app.authorized.by/" target="_blank">En espera de autorización</a>',
  [i18n.contents.texts.tuvMember]: 'authorized.by | TÜV Saarland Group',
  [i18n.contents.texts.t0Message]: "¡Vuelva pronto para conocer las marcas autorizadas!",

  [i18n.contents.texts.originalityConfirmedTitle]: "Originality confirmed",
  [i18n.contents.texts.originalityConfirmedText]: "{url} expressly guarantees the originality of this product.",
  [i18n.contents.texts.authRetailerTitle]: "Authorized partner",
  [i18n.contents.texts.authRetailerText]: "{url} is specifically authorized for the online sale of this product by {brand} and is a trusted partner of the brand.",
  [i18n.contents.texts.shopCheckTitle]: 'Shop identity checked',
  [i18n.contents.texts.shopCheckText]: 'The company details on the identity of the shop provider {url} were last checked as part of TÜV Saarland ShopIdent procedure in {date}.',

  [i18n.contents.texts.shopCheckTitle_brandSponsored]: 'Safe shopping',
  [i18n.contents.texts.shopCheckText_brandSponsored]: '{url} meets the specific requirements of {brand} and is a trusted partner of the brand.',

  [i18n.contents.texts.originalityConfirmedTitle_d2c]: "La tienda oficial de la marca",
  [i18n.contents.texts.originalityConfirmedText_d2c]: "{url} es la tienda oficial de la marca y opera en nombre de {brand}.",
  [i18n.contents.texts.authRetailerTitle_d2c]: "Directo del fabricante",
  [i18n.contents.texts.authRetailerText_d2c]: "{url} ofrece productos de marca directamente del fabricante {brand}.",
  [i18n.contents.texts.shopCheckTitle_d2c]: 'Identidad verificada',
  [i18n.contents.texts.shopCheckText_d2c]: 'Los detalles de la empresa sobre la identidad del proveedor de la tienda {url} se verificaron por última vez como parte del procedimiento TÜV Saarland ShopIdent en {date}.',
  [i18n.contents.texts.shopCheckTitle_noTuv_d2c]: 'Compras seguras',
  [i18n.contents.texts.shopCheckText_noTuv_d2c]: '{url} cumple con los requisitos específicos de {brand} y es la tienda oficial de la marca.',

  [i18n.footer.showCertificate]: 'SHOW CERTIFICATE',
};
